import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';

import { cn } from '@lib/utils';

const Separator = (props: React.ComponentProps<typeof SeparatorPrimitive.Root>) => {
  const { className, decorative = true, orientation = 'horizontal', ...otherProps } = props;

  return (
    <SeparatorPrimitive.Root
      className={cn('shrink-0 bg-border', orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px', className)}
      decorative={decorative}
      orientation={orientation}
      {...otherProps}
    />
  );
};
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
